import { render } from "./TopCard.vue?vue&type=template&id=55b67394&scoped=true"
import script from "./TopCard.vue?vue&type=script&lang=js"
export * from "./TopCard.vue?vue&type=script&lang=js"

import "./TopCard.vue?vue&type=style&index=0&id=55b67394&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b67394"]])

export default __exports__